<template>
  <div>
    <div class="px-8 md:px-8 pb-8 md:pt-12">
      <div class="py-3"></div>
      <div class="flex justify-center gap-16" v-if="false">
        <button
          class="border w-[30%] p-4 shadow-lg rounded-2xl flex flex-col items-center ripple"
          @click="copyLink"
        >
          <div class="w-2/3 p-2">
            <img src="@/assets/images/all/link.svg" alt="" class="w-full" />
          </div>
          <div class="text-center">
            {{ $t('affiliation.copyLink') }}
          </div>
        </button>
        <button
          class="border w-[30%] p-4 shadow-lg rounded-2xl flex flex-col items-center ripple"
          @click="copyCode"
        >
          <div class="w-2/3">
            <img
              src="@/assets/images/all/copy-white.svg"
              alt=""
              class="w-full"
            />
          </div>
          <div class="text-center">
            {{ $t('affiliation.copyCode') }}
          </div>
        </button>
      </div>
    </div>
    <div class="py-0"></div>
    <div class="border-t"></div>
    <div class="py-8"></div>
    <div class="px-6 md:px-6 pb-10 md:pt-12 gap-6">
      <div class="text-center text-lg">Code d'affiliation</div>
      <div class="py-4"></div>

      <div class="">
        <button
          @click="copyCode"
          class="relative ripple rounded-xl !bg-transparent small shadow-none !py-3 !px-2 title-color border-white border border-dashed hover:!saturate-100 w-full"
        >
          <div class="absolute -top-[15px] left-[4px] opacity-100 text-sm pr-2">
            <span class="opacity-80"> Code d'affiliation </span>
          </div>
          <div class="w-full flex justify-between text-left items-center">
            <span class="opacity-90">
              {{ appData?.affiliationCode || 'XXX-XXX' }}
            </span>
            <div class="w-6 h-6">
              <img
                src="@/assets/images/all/copy-white.svg"
                alt=""
                class="w-full h-full"
              />
            </div>
          </div>
        </button>
      </div>
      <div class="py-4"></div>

      <div class="">
        <button
          @click="copyLink"
          class="relative ripple rounded-xl !bg-transparent small shadow-none !py-3 !px-2 title-color border-white border border-dashed hover:!saturate-100 w-full"
        >
          <div class="absolute -top-[15px] left-[4px] opacity-100 text-sm pr-2">
            <span class="opacity-80">
              {{ $t('affiliation.myAffiliateLink') }}
            </span>
          </div>
          <div class="w-full flex justify-between text-left items-center">
            <span class="opacity-90">
              {{ appData?.affiliationUrl || 'XXX-XXX' }}
            </span>
            <div class="w-6 h-6">
              <img
                src="@/assets/images/all/copy-white.svg"
                alt=""
                class="w-full h-full"
              />
            </div>
          </div>
        </button>
      </div>
      <div class="py-6"></div>
      <!-- <div class="text-center text-lg">Personnaliser</div>
      <div class="py-2"></div> -->

      <div class="text">
        Envie d'un code d'affiliation personnalisé  (Ex: VIC-32) ?
        <div class="pt-1"></div>
        <div class="items-center   gap-2">
          <div class="">Faites la demande.</div>
        <div class="pt-1"></div>
          <div class="">
            <button
              class="buttonComponent bg-none !bg-white small shadow-none !py-3 !px-4 text-[#002E5E]"
              @click="
                () => {
                  changeAffiliationCode()
                }
              "
            >
              Faire la demande
            </button>
          </div>
        </div>
      </div>

      <div class="py-6"></div>
      <div class="text-center text-lg">Partager le lien</div>
      <div class="py-2"></div>

      <div class="flex justify-between px-4">
        <div
          class="flex flex-col items-center gap-3 justify-center"
          v-for="(sharing, i) in sharings"
          :key="i"
          :data-sharer="sharing.type"
          :data-title="`\nSalut.\n\n Télécharge King Recharge et fais tes recharges et retraits 1xBet, Betwinner, Melbet, 888Starz 1Win et autre. \n\n King Recharge est gratuit`"
          :data-url="urlToShare"
        >
          <div
            class="ripple rounded-full w-20 h-20 flex items-center justify-center p-5"
            :class="[sharing.class]"
          >
            <img :src="sharing.logo" alt="" class="w-full h-full" />
          </div>
          <div class="text-sm">{{ sharing.name }}</div>
        </div>
        <!-- <div
          @click="copyCode"
          class="flex flex-col items-center gap-4 justify-center"
        >
          <div
            class="ripple rounded-full w-16 h-16 flex items-center justify-center p-5"
            :class="[sharings[0].class]"
          >
            <img
              src="@/assets/images/all/copy-white.svg"
              alt=""
              class="w-full h-full"
            />
          </div>
          <div class="text-sm">{{ $t('affiliation.copyCode') }}</div>
        </div> -->
      </div>

      <!-- <div class="py-2"></div> -->
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import whatsappIcon from '@/assets/images/all/whatsapp-green.svg'
import telegramIcon from '@/assets/images/all/telegram-blue.svg'
import emailIcon from '@/assets/images/all/gmail.png'
import facebookIcon from '@/assets/images/all/facebook-blue.svg'

export default defineComponent({
  name: 'TransactionDetailsComponent',
  components: {},
  props: {
    appData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      sharings: [
        {
          type: 'whatsapp',
          logo: whatsappIcon,
          name: 'Whatsapp',
          class: 'glassBg',
        },
        {
          type: 'telegram',
          logo: telegramIcon,
          name: 'Télégram',
          class: 'glassBg',
        },
        {
          type: 'email',
          logo: emailIcon,
          name: 'Gmail',
          class: 'glassBg',
        },
        {
          type: 'facebook',
          logo: facebookIcon,
          name: 'Facebook',
          class: 'glassBg',
        },
      ],
    }
  },
  async mounted() {
    this.loadSharing()
  },
  methods: {
    loadSharing() {
      setTimeout(() => {
        window.Sharer.init()
      }, 500)
    },
    copyLink() {
      this.$Commons.copy(
        this.appData?.affiliationUrl,
        this.$t('affiliation.linkCopied'),
      )
    },
    copyCode() {
      this.$Commons.copy(
        this.appData?.affiliationCode,
        this.$t('affiliation.codeCopied'),
      )
    },
    async changeAffiliationCode(code) {
      const prompt = await window.customPrompt({
        title: 'Personnalisez votre code promo',
        subTitle: 'Saissisez dans le champ ci-dessous le nouveau code',
        formFields: [
          {
            type: 'text',
            propertyName: 'code',
            label: "Nouveu code d'affiliation",
            defaultValue: code || this.affiliationCode,
            required: true,
          },
          {
            type: 'text',
            propertyName: 'code',
            label: '',
            defaultValue: code || this.affiliationCode,
            required: true,
            inputProps: {
              disabled: true,
              prefix: 'https://kingrecharge.com?ref=',
            },
            class:
              '[&_input]:!pl-[25ch] [&_input]:!-top-[0.2rem]  [&_input]:!relative [&_input]:!text-primary-300 [&_input]:!font-bold  [&_.prefix]:!opacity-50 ',
          },
        ],
        successText: 'Modifier',
      })
      if (!prompt.accepted) return
      this.$Events.dispatchEvent('start_loading')
      await new Promise(r => setTimeout(r, 300))
      const response = await this.$Events.sendDataRequestResolve(
        'customizeAffiliationCode',
        {
          code: prompt.data.code,
        },
      )
      this.$Events.dispatchEvent('finish_loading')
      if (response.success) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Demande envoyée',
          body: 'Les administrateur valideront au plus tot votre nouveau code. Nous vous enverront une notification pour vous informer',
        })
      } else {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Echec de la demande',
          body:
            response.message ||
            "Veuillez réessayer à nouveau. Une erreur s'est produite lors de la demande",
        })
        this.changeAffiliationCode(prompt.data.code)
      }
    },
  },
  computed: {
    affiliationCode() {
      return this.appData?.affiliationCode
    },
    urlToShare() {
      return this.appData?.affiliationUrl
    },
    affiliationDetailText() {
      return this.appData?.affiliationDetailText
    },
  },
})
</script>
